import React from "react";
import ShelfTemplate from "./index";

export default function ToReadList(){
 
    return (
      <div>
        <ShelfTemplate 
        shelfUrl="readingList" 
        header="Books to Read"

        />
      </div>
    );
  
}
